import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, FlatButton, Paper } from 'material-ui';
import Subheader from 'material-ui/Subheader';
import { connect } from 'react-redux';
import Error from '../../components/common/Error/Error';
import Loading from '../../components/common/Loading/Loading';
import { fetchApp, getSubscribedPush, resetSubscribedPush } from '../../store/apps/actions';
import { getTypes } from '../../store/types/actions';
import { getCustomFields } from '../../store/customfields/actions';
import style from '../../styles/styles';
import styles from './AddNewsPage.css';
import { postOneNews } from '../../store/news/actions';
import NewsForm from '../../components/news/NewsForm';
import { dispatchInfo } from '../../store/infos/actions';
import { NEWS_PAGE } from '../../constants/routes';
import withTranslation from '../../hoc/withTranslation';
import CustomFieldService from '../../services/customfield';

export class AddNewsPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
    };

    static defaultProps = {};

    state = {
        shouldCreateNew: false,
        title: null,
        pushModalOpened: false,
        waitingFormProps: null,
    };

    componentWillMount() {
        this.fetchApplication();
        if (this.props.app) {
            this.props.getTypes(this.props.app.id, this.props.lang);
            this.props.getCustomFields(this.props.app.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.app && this.props.app !== nextProps.app) {
            this.props.getTypes(nextProps.app.id, nextProps.lang);
            this.props.getCustomFields(nextProps.app.id);
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending && nextProps.news) {

            if (this.state.shouldCreateNew) {
                this.props.dispatchInfo(nextProps.news.title + ' saved');
            }

            if (!this.state.shouldCreateNew) {
                let url = NEWS_PAGE
                    .replace(':appId', this.props.app.id)
                    .replace(':newsId', nextProps.news.id);
                this.props.history.push(url);
            }
        }

        if (this.state.shouldCreateNew) {
            this.setState({ shouldCreateNew: false });
        }
    }

    // Fetch

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        if (formProps.push_entity) {
            let pushFormProps = {
                message: formProps.title,
                groups: ['news'],
                langs: ['fr', 'en'],
            };
            await this.props.getSubscribedPush(this.props.app.id, pushFormProps);
            this.handleOpenPushModal(formProps);
        } else {
            await this.handlePostData(formProps);
        }
    };

    handleOpenPushModal = (formProps) => {
        this.setState({
            pushModalOpened: true,
            waitingFormProps: formProps,
        });
    };

    handleClosePushModal = () => {
        this.setState({
            pushModalOpened: false,
            waitingFormProps: null,
        });
        this.props.resetSubscribedPush();
    };

    handlePostData = async (formProps) => {
        if (formProps === null && this.state.waitingFormProps === null) {
            return;
        }
        if (formProps === null) {
            formProps = this.state.waitingFormProps;
        }
        await this.props.postOneNews(this.props.app.id, formProps, this.props.lang);
    };

    handleValidPostAndPushData = (event) => {
        event.stopPropagation();
        this.handlePostData(this.state.waitingFormProps);
    };

    handleFormReset = () => {
        this.setState({
            title: null,
            shouldCreateNew: true,
        });
    };

    handleFormSubmitDuplication = async (formProps) => {
        await this.props.postOneNews(this.props.app.id, formProps, this.props.lang);
    };

    // Render

    renderPushDialog() {
        const actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                primary={false}
                onClick={this.handleClosePushModal}
            />,
            <FlatButton
                label={this.props.t('generic.push')}
                primary={true}
                onClick={this.handleValidPostAndPushData}
            />,
        ];

        return (
            <Dialog
                title={this.props.t('generic.push_notification')}
                actions={actions}
                modal={false}
                open={this.state.pushModalOpened}
                onRequestClose={this.handleClosePushModal}
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html:
                            this.props.t('module.push.push_confirmation', {
                                name: this.props.app.name,
                            }),
                    }}
                />

                {this.props.subscribedToPush &&
                    <div>
                        <div
                            dangerouslySetInnerHTML={{
                                __html:
                                    this.props.t('module.push.device_count', {
                                        count: this.props.subscribedToPush,
                                    }),
                            }}
                        />
                    </div>
                }
            </Dialog>
        );
    }

    render() {
        const { location } = this.props;
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>
                        {this.props.t('module.news.news_add', { name: this.props.app.name })}
                    </h3>
                    <div className="row">
                        <div
                            style={style.col}
                            className="col-xs-12 col-sm-12 col-md-12"
                        >
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>
                                    {this.props.t('module.news.new_news')}
                                </Subheader>
                                <div style={style.paper}>
                                    {
                                        // Here to display duplicate form or add form.
                                        location.state && location.state.isDuplicate
                                            ? <NewsForm
                                                customFields={
                                                    CustomFieldService.filter(
                                                        this.props.customFields,
                                                        CustomFieldService.NEWS,
                                                    )
                                                }
                                                onFormReset={this.handleFormReset}
                                                onSubmit={this.handleFormSubmitDuplication}
                                                initialValues={this.props.initialValues}
                                                submitting={this.props.sending}
                                                news={this.props.news}
                                                app={this.props.app}
                                                enableReinitialize={true}
                                                types={this.props.types}
                                            />
                                            : <NewsForm
                                                customFields={
                                                    CustomFieldService.filter(
                                                        this.props.customFields,
                                                        CustomFieldService.NEWS,
                                                    )
                                                }
                                                onFormReset={this.handleFormReset}
                                                onSubmit={this.handleFormSubmit}
                                                submitting={this.props.sending}
                                                app={this.props.app}
                                                types={this.props.types}
                                            />
                                    }
                                </div>
                                <div style={style.clear} />
                            </Paper>
                        </div>
                    </div>
                    {this.renderPushDialog()}
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending
            || state.news.pending
            || state.types.pending
            || state.customFields.pending,
        error: state.apps.error,
        news: state.news.currentNews,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        sending: state.news.sending,
        types: state.types.content,
        subscribedToPush: state.apps.subscribedToPush,
        customFields: state.customFields.content,
    };
    const news = state.news.currentNews;
    if (news) {
        let initValues = { ...news };

        if (news.custom_fields) {
            news.custom_fields.forEach((cf) => {
                initValues[cf.id] = cf.value;
            });
        }
        props.initialValues = initValues;
    }

    return props;
}

export default connect(mapStateToProps, {
    postOneNews,
    getSubscribedPush,
    resetSubscribedPush,
    fetchApp,
    getCustomFields,
    dispatchInfo,
    getTypes,
})(withTranslation(AddNewsPage));



// WEBPACK FOOTER //
// src/containers/news/AddNewsPage.js